import { Row, Col, Container } from "react-bootstrap";
import OwnerShopProfile from "../../components/OwnerShopProfile/OwnerShopProfile";
import ShopItemsOwner from "../../components/ShopItemsOwner/ShopItems";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import BackArrow from "../../components/backArrow";
import ShopManagebuttons from "../../components/Shops_manage_buttons";
import { useSelector } from "react-redux";
import { extractIdFromSlug } from "../../utils/slugUtils";
import {
  useGetShopByIdQuery,
  useLazyGetShopSuggestionsByVendorIdQuery,
} from "../../features/shop/shopApiSlice";

const HomeMadeOwnerProfile = () => {
  const { id: slugId } = useParams();
  const id = extractIdFromSlug(slugId);
  const [shopData, setShopData] = useState();
  const [suggest, setSuggest] = useState(0);
  const [suggestdetail, setSuggestdetail] = useState(0);
  const { name } = useSelector((state) => state.user);
  const [suggestdata, setSuggestdata] = useState();

  const { data: shopRes } = useGetShopByIdQuery(id, { skip: !id });

  useEffect(() => {
    if (shopRes?.data?.Shop) {
      setShopData(shopRes.data.Shop);
    }
  }, [shopRes]);

  const currentUserId = name?._id || name?.id;
  const shopOwnerId = shopData?.userid?._id || shopData?.userid;
  const isOwner = Boolean(
    currentUserId &&
      shopOwnerId &&
      String(currentUserId) === String(shopOwnerId),
  );

  const [triggerGetSuggestions] = useLazyGetShopSuggestionsByVendorIdQuery();

  const suggestdatta = () => {
    if (shopData?._id) {
      triggerGetSuggestions(shopData._id).then((res) => {
        setSuggestdata(res?.data?.data?.[0]?.suggestions);
      });
    }
  };

  return (
    <Container>
      <Col md={12} lg={11} className="mx-auto">
        <Row>
          <Col md={4} lg={3} className="p-0">
            <OwnerShopProfile
              suggestdatta={suggestdatta}
              shopid={id}
              salespromotion="sales promotion"
              icon={<LocalOfferIcon className="silver-icon" />}
              shopData={shopData}
              setSuggest={setSuggest}
              Name="Update Home Made Items Profile"
              navigateTo="/homemade-update"
            />
          </Col>
          <Col md={8} lg={9} className=" screenHeight custom_ps-4">
            <div className="Form-Shadow h-100">
              <Row>
                <Col lg="4">
                  <BackArrow
                    back={`/rawmaterial-homemade/${id}`}
                    mystyle="ps-2 pt-1 d-none d-lg-block"
                  />
                </Col>
                <Col lg="8" className="mt-2 pe-4 mb-4">
                  <ShopManagebuttons
                    businessurl="/homemade-items-shops"
                    shopid={id}
                    shopData={shopData}
                    isOwner={isOwner}
                  />
                </Col>
              </Row>
              <ShopItemsOwner
                urlPass="/homeMade-item-owner-view"
                shopid={id}
                shopData={shopData}
                suggestdata={suggestdata}
                suggest={suggest}
                setSuggest={setSuggest}
                suggestdetail={suggestdetail}
                setSuggestdetail={setSuggestdetail}
                navigateto="/Home-Made-Form"
                post={`/homemade-postAdd/${id}`}
              />
            </div>
          </Col>
        </Row>
      </Col>
    </Container>
  );
};

export default HomeMadeOwnerProfile;
